import { POST_CREATE_NEWTAB_FAILURE, POST_CREATE_NEWTAB_REQUEST, POST_CREATE_NEWTAB_SUCCESS } from '../action/types'

const initialState = {
  data: [],
  error: '',
  loading: false,
}

export const createNewTabReducer = (state = initialState, action) => {
  switch (action.type) {
    case POST_CREATE_NEWTAB_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case POST_CREATE_NEWTAB_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      }
    case POST_CREATE_NEWTAB_FAILURE:
      return {
        data: [],
        error: action.payload,
        loading: false,
      }
    default:
      return state
  }
}
